module.exports = __webpack_public_path__ + "files/07510ed019e317ee10bb5a26012e1069.woff2";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/katex/dist/fonts/KaTeX_Main-Italic.woff2
// module id = 1183
// module chunks = 76